module.exports = __webpack_public_path__ + "static/img/feiji.dbaf7886.png";